/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Button, Empty, Tabs, TabsProps} from "antd";
import {WarningOutlined} from '@ant-design/icons';
import BaechaWorkDayTable from "./BaechaWorkDayTable";
import {BaechaWorkDay} from '../../../types/BaechaWorkDay';
import BaechaUpdateHistoryTable from "./BaechaUpdateHistoryTable";
import {BaechaUpdateHistory} from "../../../types/BaechaUpdateHistory";
import {Baecha} from "../../../types/Baecha";

interface BaechaWorkDayDetailProps {
	baechaData: Baecha | undefined;
	baechaWorkDayData: BaechaWorkDay[];
	baechaUpdateHistoryData: BaechaUpdateHistory[];
	onClickBaechaWorkDay: (baechaWorkDay: BaechaWorkDay, action: 'edit' | 'delete' | 'done') => void;
	onClickAddButton: () => void;
}

const BaechaWorkDayDetail = ({
	                             baechaData,
	                             baechaWorkDayData,
	                             baechaUpdateHistoryData,
	                             onClickBaechaWorkDay,
	                             onClickAddButton,
                             }: BaechaWorkDayDetailProps) => {
	const tabContentStyle: React.CSSProperties = {
		width: '100%',
		height: '100%',
		overflow: 'auto',
	};

	const getIsShowAddBtn = () => {
		if (baechaData?.isWorkMonth) return false;
		if (baechaData?.status === 'balju_cancel') return false;
		return !baechaWorkDayData.every((item) => item.doneDate || item.doneMemberId);
	};

	const items: TabsProps['items'] = [
		{
			key: '1',
			label: '작업 상세',
			children: (
				<div style={{
					...tabContentStyle,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					gap: '10px',
					marginBottom: '5px'
				}}>
					{baechaWorkDayData.length === 0
						? <Empty/>
						: (
							<>
								<div style={{ textAlign: 'left', width: '100%' }}>
									<WarningOutlined style={{ color: 'red', marginRight: '5px' }}/>
									단가 상향은 작업시간이 줄어든 경우에만 가능합니다.
								</div>
								<BaechaWorkDayTable
									baechaData={baechaData}
									baechaWorkDayData={baechaWorkDayData}
									onClickBaechaWorkDay={onClickBaechaWorkDay}
								/>
							</>
						)}
					{getIsShowAddBtn()
						&& (
							<Button onClick={onClickAddButton}>
								추가
							</Button>
						)}
				</div>
			),
		},
		{
			key: '2',
			label: '작업 이력',
			children: (
				<div style={{...tabContentStyle, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px'}}>
					{baechaUpdateHistoryData.length === 0
						? <Empty/>
						: <BaechaUpdateHistoryTable data={baechaUpdateHistoryData}/>
					}
				</div>
			)
		},
	]

	return (
		<div>
			<Tabs
				defaultActiveKey="1"
				items={items}
				style={{width: '100%', height: '100%'}}
				animated={false}
				destroyInactiveTabPane
			/>
		</div>
	);
};

export default BaechaWorkDayDetail;
